import { useSelector } from 'react-redux'
import { userProfileSelector } from './reducer'

export function useUserProfileDisplay() {
  const userProfile = useSelector(userProfileSelector)

  return userProfile
}
